/*
 * The texts of the widgets extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		dashboard: {
			add_widget: 'Add widget',
			save: 'Save dashboard',
			delete_all: 'Delete all widgets',
		},
	},
	// Display names of the lib's dashboard widgets, key derived from the type (see dashboard registry)
	widgets: {
		me: {
			title: 'My profile',
		},
		date_time: {
			title: 'Date and time',
		},
	},
	confirms: {
		dashboard: {
			delete_widget: {
				title: 'Delete widget',
				text: 'Remove the widget "{name}" from the dashboard?',
			},
			delete_all: {
				title: 'Delete all widgets',
				text: 'Remove the widget from the dashboard? | Remove all {count} widgets from the dashboard?',
			},
		},
	},
};
